// extracted by mini-css-extract-plugin
module.exports = {"data":"AddGameModal_data__dNooX"};